import { useMemo } from "react";
import {
  normalizeCanvasSizePreset,
  resolveCanvasRect,
  type CanvasFrame,
} from "@refinement-canvas/domain";
import { useCanvasDocStore } from "./store/canvas-doc-store";

// 現在のキャンバス矩形（ステージ座標での原点 + 寸法）。
// サイズプリセット（小 / 中 / 大。未設定は中）から導出する。中(10K)の中心を固定中心とするため、
// 中は原点 (0,0)、小は内側へ、大は原点が負値になり外側へ広がる（図形は動かさない中心基準リサイズ）。
export function useCanvasRect(): CanvasFrame {
  const sizePreset = normalizeCanvasSizePreset(useCanvasDocStore((s) => s.meta.sizePreset));
  return useMemo(() => resolveCanvasRect(sizePreset), [sizePreset]);
}
